module.exports = __webpack_public_path__ + "static/media/resume-news.48848677.png";